<script>

export default {
  props: {
    num: {
      type: Number
    },
    isActived: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }

}
</script>
<template>
  <div class="detect-step">
    <div
      class="detect-step-icon"
      :class="{
        success: status === 'success',
        fail: status === 'fail'
      }"
    ></div>
    <p class="detect-step-text"
    :class="{
      'detect-step-text__inactive': !isActived,
      'fail-text': status === 'fail'
    }"
    >
      {{ name }}
    </p>

  </div>
</template>
<style lang="scss" scoped>
.detect-step {
  display: flex;
  align-items: center;
}

.detect-step-icon {
  width: 12px;
  height: 12px;
  border: 3px solid #d1d7e1ff;
  border-radius: 50%;
}
.detect-step-text {
  font-size: 14px;
  color: #000000D9;
  margin-left: 10px;
  font-weight: 400;
}
.detect-step-text__inactive {
  color: #00000073;
}
.status-icon {
  width: 12px;
  height: 12px;
  margin-left: 6px;
  margin-bottom: 8px;
}

.success {
  border-color: #52c41aff;
}
.fail {
  border-color: #ff4d4fff;
}
.fail-text {
  color: #ff4d4fff;
}
</style>
